__turbopack_context__.v({
  "form": "form-module-scss-module__hhSEPW__form",
  "inputs": "form-module-scss-module__hhSEPW__inputs",
  "job": "form-module-scss-module__hhSEPW__job",
  "location": "form-module-scss-module__hhSEPW__location",
  "typeaheads": "form-module-scss-module__hhSEPW__typeaheads",
});
